<template>
  <div
    class="
      section section-tabs
      page-header page-header-smaller
      clear-filter
      section-download
    "
    filter-color="black"
  >
    <div
      class="page-header-image"
      v-bind:style="{
        'background-image':
          'url(' + myTheme.download_section_background_image + ')',
      }"
    ></div>
    <div class="container">
      <div class="row">
        <div class="col-md-10 ml-auto col-xl-6 mr-auto">
          <el-image :src="myTheme.download_section_left_image" class="rounded">
          </el-image>
        </div>
        <div class="col-md-10 ml-auto col-xl-6 mr-auto">
          <div class="text-center">
            <h1>{{ myTheme.download_section_title }}</h1>
            <p>{{ myTheme.download_section_body }}</p>
            <div class="appstore-icons">
              <a :href="getStoreLinks && getStoreLinks.appStore ? getStoreLinks.appStore : null" target="_blank">
              <el-image src="img/apple.png" style="height:66px" ></el-image>
              </a>
              <a :href="getStoreLinks && getStoreLinks.playStore ? getStoreLinks.playStore : null" target="_blank">
              <el-image src="img/google.png" style="height:66px"></el-image>
              </a>
            </div>
          </div>
          <div>
            <el-image :src="getAppLogo" class="rounded wtf-img"></el-image>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "download-section",
  computed: {
    ...mapGetters('locationStore',["getStoreLinks", "getBusiness"]),
    getAppLogo() {
      return `img/logo_${
        this.getBusiness ? this.getBusiness.territory.toLowerCase() : "en"
      }.png`;
    },
  },
};
</script>
<style scoped>
.section-tabs.page-header.page-header-smaller {
  max-height: none;
}
.wtf-img {
  margin-top: 5%;
  margin-bottom: 5%;
  max-width: 55%;
  height: auto;
}
.appstore-icons {
  display: inline-grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 5px;
  max-width: 70%;
}
</style>